import { hasSession, redirectToLogin } from "./authSession";

const PING_MS = 20000;
const LEADER_STALE_MS = 45000;
const LEADER_KEY = "procurement.pingLeader";
const TAB_KEY = "procurement.tabId";

const tabId = () => {
  let id = sessionStorage.getItem(TAB_KEY);
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(TAB_KEY, id);
  }
  return id;
};

// The visible tab pings for this browser. Hidden tabs stay quiet unless
// the leader has gone, so ten tabs do not mean ten requests.
const claimLeadership = (id) => {
  let leader = null;
  try {
    leader = JSON.parse(localStorage.getItem(LEADER_KEY) || "null");
  } catch {
    leader = null;
  }
  const now = Date.now();
  const stale = !leader?.at || now - Number(leader.at) > LEADER_STALE_MS;
  const visible = document.visibilityState === "visible";
  if (leader?.id !== id && !stale && !visible) {
    return false;
  }
  localStorage.setItem(LEADER_KEY, JSON.stringify({ id, at: now }));
  return true;
};

export const startSessionPing = () => {
  if (typeof window === "undefined") {
    return () => {};
  }
  const id = tabId();
  let stopped = false;

  const tick = async () => {
    if (stopped || !hasSession() || !claimLeadership(id)) {
      return;
    }
    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      return;
    }
    try {
      const response = await fetch(`${apiUrl.replace(/\/+$/, "")}/auth/ping`, {
        method: "POST",
        credentials: "include",
      });
      if (response.status === 401) {
        redirectToLogin();
      }
    } catch {
      // A short outage must not sign the user out.
    }
  };

  const timer = window.setInterval(() => {
    void tick();
  }, PING_MS);
  void tick();

  return () => {
    stopped = true;
    window.clearInterval(timer);
  };
};
